import qs from 'qs'

import { getConnectionUrl } from './utils'

interface IResponse<Data> {
  message: string
  data: Data
}

interface IGetApi<TParams> {
  path: string
  params?: TParams
  headers?: Record<string, string>
}

interface IPostApi<TBody> {
  path: string
  body: TBody
  headers?: Record<string, string>
}

const throwHttpError = (status: number): never => {
  const error = new Error(`HTTP error: ${status}`) as Error & { response: { status: number } }

  error.response = { status }
  throw error
}

export const apiGet = async <TParams extends object, TResponse>({
  path,
  params,
  headers,
}: IGetApi<TParams>): Promise<IResponse<TResponse>> => {
  const baseUrl = getConnectionUrl(path)
  const url = params ? `${baseUrl}?${qs.stringify(params, { indices: false })}` : baseUrl

  const response = await fetch(url, { credentials: 'include', headers })

  if (!response.ok) {
    throwHttpError(response.status)
  }

  return response.json() as Promise<IResponse<TResponse>>
}

export const apiPost = async <TBody, TResponse>({
  path,
  body,
  headers,
}: IPostApi<TBody>): Promise<IResponse<TResponse>> => {
  const url = getConnectionUrl(path)

  const response = await fetch(url, {
    method: 'POST',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
      ...headers,
    },
    body: JSON.stringify(body),
  })

  if (!response.ok) {
    throwHttpError(response.status)
  }

  return response.json() as Promise<IResponse<TResponse>>
}
